import { useEmptyState } from "common/Icons/useEmptyState.tsx";
import styled, { css, useTheme } from "styled-components";
import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import { useBranding } from "@shared/utils/hooks/useBranding.ts";

const NoConnectChannelError = () => {
  const { Bots } = useEmptyState();
  const { isWhitelabel } = useBranding();
  const { isNewLook } = useTheme();

  const textStyle: React.CSSProperties = { textAlign: "center" };

  return (
    <Wrapper>
      <Bots style={{ marginBottom: 20, height: isNewLook ? 160 : 200 }} />
      <StyledTitle style={{ marginBottom: 8 }}>
        Signals Channel Not Connected
      </StyledTitle>
      <Text style={textStyle}>
        You're early! The group owner hasn't connected a signals channel yet.
      </Text>
      <Text style={textStyle}>
        {`${
          isWhitelabel ? "The platform" : "Cornix"
        } will be available as soon as the setup is completed.`}
      </Text>
      <Text style={textStyle}>No action is needed from you right now.</Text>
    </Wrapper>
  );
};

export default NoConnectChannelError;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 50px auto auto;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      max-width: 520px;
      margin-top: 72px;
      > p {
        color: ${p.theme.colors.secondaryText};
        font-size: 14px;
        line-height: 1.6;
      }
    `}
`;
const StyledTitle = styled(Title)`
  ${(p) =>
    p.theme.isNewLook &&
    css`
      text-align: center;
      color: ${p.theme.colors.titleColor};
      font-size: 22px;
      font-weight: ${p.theme.typography.fontWeights.BOLD};
      letter-spacing: -0.01em;
    `}
`;
